import { mapKeys, camelCase } from 'lodash'

export class Pagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

class QueryBuilder {
  constructor({ include, fields, append, sort } = {}) {
    this.include = include
    this.fields = fields
    this.append = append
    this.sort = sort
  }
}

export const baseState = {
  resources: [],
  search: null,
  pagination: new Pagination(),
  queryBuilder: new QueryBuilder()
}

export const baseMutations = {
  RECEIVE_RESOURCES(state, { data, meta }) {
    state.resources = []
    data.forEach(resource => {
      state.resources.push(Object.assign(resource, { _deleting: false }))
    })

    state.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
  },
  SET_SEARCH(state, search) {
    if (search === '') state.search = null
    else state.search = search
  },
  RESET_CURRENT_PAGE(state) {
    state.pagination.currentPage = 1
  },
  RESET_PAGINATION(state) {
    state.pagination = new Pagination()
  },
  RESET_STATE(state) {
    state.resources = []
    state.search = null
    state.pagination = new Pagination()
  },
  SET_QUERY_BUILDER(state, attributes) {
    state.queryBuilder = new QueryBuilder(attributes)
  }
}
